// @ts-strict-ignore
import {
  getImmersiveOnboardingSetupGuideInfo,
  updateSetupGuideInfo,
  updateStepsCompleted,
  V1_1,
  Version,
} from 'common/report/queries/app-api/immersive-onboarding';

import {IndustryKey, SetupGuideResponse, SetupGuideType, Step} from './types';

// API client with transform; could merge with context to automate invalidation
const convert = (response: SetupGuideResponse): SetupGuideType => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const {steps_completed, events_properties_map, ...rest} = response;

  return {
    ...rest,
    events: response.events ?? [],
    eventsPropertiesMap: response.events_properties_map ?? {},
    stepsCompleted: new Set(steps_completed as Step[]),
    projectId: response.project_id,
    projectToken: response.project_token,
    industry: response.industry as IndustryKey,
  };
};

// Return type of this client should always be SetupGuideType
export const ApiClient = {
  get: async (projectId: number, version: Version = V1_1, forceRefresh = false): Promise<SetupGuideType> => {
    const result = await getImmersiveOnboardingSetupGuideInfo(projectId, version, forceRefresh);
    return convert(result);
  },
  updateCompleted: async (projectId: number, stepsCompleted: Set<Step>): Promise<SetupGuideType> => {
    const completedStepsSet = Array.from(stepsCompleted);
    const result = await updateStepsCompleted(projectId, completedStepsSet);
    return convert(result);
  },
  updateSetupGuideInfo: async (
    projectId: number,
    industry: IndustryKey,
    events?: string[],
    eventsPropertiesMap?: Map<string, string[]>,
  ): Promise<SetupGuideType> => {
    const result = await updateSetupGuideInfo(projectId, industry, events, Object.fromEntries(eventsPropertiesMap));
    return convert(result);
  },
};
